import React, { useState, useEffect } from "react";
import api from "../../services/api";
import * as S from "./styles";
import { toast } from "react-toastify";

const ListPapelUsuario = ({ onChange, ...props }) => {
  const [valueValid, setValueValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [listPapelUsuario, setListPapelUsuario] = useState([]);

  useEffect(() => getAllCategoryStoreType(), []);

  async function getAllCategoryStoreType() {
    setIsLoading(true);
    try {
      const response = await api.get(`/api/papel/usuario`);
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        let listPapelUsuario = response?.data || [];

        if (listPapelUsuario.length != 0) {
          listPapelUsuario = [
            { id: 0, descricao: "Selecione...", ordem: 0 },
          ].concat(listPapelUsuario);
        }

        setListPapelUsuario(listPapelUsuario);

        const optionsResult = listPapelUsuario.map((currOption, index) => {
          return (
            <S.Option key={index} value={currOption.id}>
              {currOption.descricao}
            </S.Option>
          );
        });

        setOptions(optionsResult);
      } else if (!response) {
        toast.error(
          "Erro ao buscar as Papel de Usuario, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar as Papel de Usuario, tente novamente mais tarde!"
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  function getPapelUsuarioById(id) {
    let papelUsuario = null;
    if (id !== 0) {
      listPapelUsuario.every(function (currPapelUsuario) {
        if (id === Number(currPapelUsuario.id)) {
          papelUsuario = currPapelUsuario;
          return false;
        }
        return true;
      });
    }
    return papelUsuario;
  }

  return isLoading ? (
    <></>
  ) : (
    <>
      <S.Label {...props}>{props.label}</S.Label>
      <S.Select
        {...props}
        valueValid={valueValid}
        onChange={(e) => {
          const id = Number(e.target.value);

          setValueValid(id !== 0);

          onChange(getPapelUsuarioById(id));
        }}
      >
        {options}
      </S.Select>
    </>
  );
};

export default ListPapelUsuario;
